import React from "react";
import { SCROLL_OFFSET, H2, BODY, CONTAINER, STEP_BACKGROUND } from "./sections";

// Four beats of the pipeline, in the order they actually happen.
const STEPS = [
  { number: "01", label: "You speak" },
  { number: "02", label: "Transcribed" },
  { number: "03", label: "AI refines" },
  { number: "04", label: "Ready text" },
];

const WhatItIsSection = () => {
  return (
    <section
      id="what-it-is"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full border-b-[1.07px] border-[#E6ECF5]"
    >
      <div
        className={`${CONTAINER} pt-[64px] pb-[64px] md:pt-[88px] md:pb-[88px] lg:pt-[112px] lg:pb-[112px]`}
      >
        <h2 className={`${H2} text-center`}>What AI voice typing really is</h2>

        <div
          className={`${BODY} mx-auto mt-[25.76px] max-w-[620px] text-center`}
        >
          <p>
            AI voice typing is technology that allows you to speak instead of
            manually typing your words.
          </p>
          <p>At its simplest, the process looks like this:</p>
        </div>

        {/* Pipeline chips */}
        <div className="mt-[30.05px] flex flex-wrap items-center justify-center gap-x-[10px] gap-y-[10px]">
          {STEPS.map(({ number, label }, index) => (
            <React.Fragment key={number}>
              {index > 0 && (
                <span
                  aria-hidden="true"
                  className="select-none text-[13px] leading-[18px] text-[#0A0D1666]"
                >
                  &#8594;
                </span>
              )}

              <span
                style={{ background: STEP_BACKGROUND }}
                className="inline-flex items-center gap-[8px] rounded-[8px] px-[13px] py-[8px] whitespace-nowrap"
              >
                <span className="font-inter text-[11.5px] font-bold leading-[18px] tracking-[0.02em] text-[#3AB1F6]">
                  {number}
                </span>
                <span className="font-jakarta text-[13px] font-semibold leading-[18px] tracking-[0px] text-[#3AB1F6]">
                  {label}
                </span>
              </span>
            </React.Fragment>
          ))}
        </div>

        <div className="mx-auto mt-[30.05px] flex max-w-[790px] flex-col gap-[25.76px] text-center">
          <p className={BODY}>
            Traditional speech recognition primarily focuses on identifying the
            words being spoken. Modern AI voice typing can take that process
            further by helping make the resulting text more readable and useful.
          </p>
          <p className={BODY}>
            That&apos;s where Zero Typing AI comes in. Rather than requiring you
            to carefully dictate every sentence and manually fix every mistake
            afterward, Zero Typing AI is designed to let you speak naturally and
            use AI-powered tools to refine the resulting text.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatItIsSection;
